module.exports = __webpack_public_path__ + "static/media/delete.c268c137.svg";